const doc = [({"en":({"js":({"admin":({"order_lines":({"expandable_content":({"orderables":({"photo_sheet_product_order_line":({"image":"Image"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;